import React, { useContext, useEffect, useState } from "react";
import "../App.css";
import useIsMobile from "./MobileQuery";
import { StartingIndexContext } from "../Context/AllContext";
import { ISortingValues } from "../exports/interfaces";
import axios from "axios";
import { headers } from "../Layout/Layout";
import { toast } from "react-toastify";

const PhoneAlphabet = () => {
  const { setStartingIndex } = useContext(StartingIndexContext);

  const [sortingValues, setSortingValues] = useState<ISortingValues[]>();

  const getPhoneSortingValues = () => {
    axios
      .get(
        `${process.env.REACT_APP_STRAPIURL}/api/entries?fields[0]=sorting_value&sort[0]=sorting_value:asc&pagination[pageSize]=99999`,
        {
          headers: headers,
        }
      )
      .then((res) => {
        setSortingValues(res?.data?.data);
      })
      .catch(() => {
        toast.error("Failed to fetch data", {
          position: "bottom-left",
        });
      }); 
  };

  useEffect(() => {
    getPhoneSortingValues();
  }, []);

  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const [activeLetter, setActiveLetter] = useState<string | null>(null);

  const handleLetter = (letter: string) => {
    setActiveLetter(letter);
    setStartingIndex(
      sortingValues &&
        sortingValues?.findIndex((item) =>
          item.attributes.sorting_value.startsWith(letter.toLowerCase())
        ) + 1
    );
  };

  const mobile = useIsMobile();
  return (
    <div className="alphabet-phone">
      {letters.map((phoneletter, index) => (
        <span
          key={index}
          className={`phoneletter${
            activeLetter === phoneletter ? " active" : ""
          }`}
          onClick={() => handleLetter(phoneletter)}
          style={{
            paddingBottom: mobile ? "4px" : "2px",
            paddingTop: mobile ? "3px" : "2px",
          }}
        >
          {phoneletter}
        </span>
      ))}
    </div>
  );
};

export default PhoneAlphabet;
